(() => {
  const inject = [
    '$sce',
    '$timeout',
  ];

  angular
    .module('app.components')
    .directive('integrationsIndicator', [...inject, (
      $sce,
      $timeout,
    ) => ({
      restrict: 'E',
      replace: true,
      scope: {
        campaign: '=',
      },
      controller: ['$scope', ($scope) => {
        $scope.fadeout = true;
        $timeout(() => {
          $scope.fadeout = false;
        }, 250);
      }],
      templateUrl: $sce.trustAsResourceUrl('/assets/js/app/components/integrations/indicator.html')
    })
  ]);
})();
